import { laporan } from '../action-types';

const initialState = {
  data: null,
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case laporan.FETCH_LAPORAN:
      return {
        ...state,
        isFetching: true,
      };
    case laporan.GET_LAPORAN:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    default:
      return state;
  }
};
